import { DEVELOPER_APP_REVIEWS, hireProofCommittedAt } from './otherAppReviews';

/**
 * Apps listed on /other and download variants on /other/:appId
 * `platform` values map to GET /api/tools/download/:app/:platform
 */
export const OTHER_APPS = [
  {
    id: 'cofounderhubs',
    name: 'CofounderHubs',
    description: 'Desktop app for browsing startups, jobs, and founder connections.',
    accent: '#07845a',
    icon: 'cofounderhubs',
    reviews: DEVELOPER_APP_REVIEWS.cofounderhubs,
    baseCounts: {
      'windows-x64': 86,
    },
    platforms: {
      macos: [],
      windows: [
        {
          id: 'windows-x64',
          label: 'Windows (x64)',
          type: 'local',
          url: '/app/CofounderHubs Setup 0.1.0.exe',
        },
      ],
      linux: [],
    },
  },
  {
    id: 'cursor',
    name: 'Cursor',
    description: 'AI-powered code editor for faster development and implementation.',
    accent: '#111111',
    icon: 'cursor',
    reviews: DEVELOPER_APP_REVIEWS.cursor,
    baseCounts: {
      'macos-arm64': 52,
      'macos-x64': 41,
      'windows-x64': 94,
      'linux-deb': 38,
      'linux-universal': 33,
    },
    platforms: {
      macos: [
        { id: 'macos-arm64', label: 'macOS (Apple Silicon)', type: 'api', platform: 'macos-arm64' },
        { id: 'macos-x64', label: 'macOS (Intel)', type: 'api', platform: 'macos-x64' },
      ],
      windows: [
        { id: 'windows-x64', label: 'Windows (x64)', type: 'api', platform: 'windows-x64' },
      ],
      linux: [
        { id: 'linux-deb', label: 'Linux (Debian/Ubuntu)', type: 'api', platform: 'linux-deb' },
        {
          id: 'linux-universal',
          label: 'Linux (Universal)',
          type: 'api',
          platform: 'linux-universal',
        },
      ],
    },
  },
  {
    id: 'kiro',
    name: 'Kiro',
    description: 'Agentic engineering IDE for specs, coding, and delivery workflows.',
    accent: '#9046FF',
    icon: 'kiro',
    reviews: DEVELOPER_APP_REVIEWS.kiro,
    baseCounts: {
      'macos-arm64': 44,
      'macos-x64': 29,
      'windows-x64': 67,
      'linux-deb': 31,
      'linux-universal': 27,
    },
    platforms: {
      macos: [
        { id: 'macos-arm64', label: 'macOS (Apple Silicon)', type: 'api', platform: 'macos-arm64' },
        { id: 'macos-x64', label: 'macOS (Intel)', type: 'api', platform: 'macos-x64' },
      ],
      windows: [
        { id: 'windows-x64', label: 'Windows (x64)', type: 'api', platform: 'windows-x64' },
      ],
      linux: [
        { id: 'linux-deb', label: 'Linux (Debian/Ubuntu)', type: 'api', platform: 'linux-deb' },
        {
          id: 'linux-universal',
          label: 'Linux (Universal)',
          type: 'api',
          platform: 'linux-universal',
        },
      ],
    },
  },
  {
    id: 'vscode',
    name: 'VS Code',
    description: 'Popular editor for building products and collaborating with teams.',
    accent: '#007ACC',
    icon: 'vscode',
    reviews: DEVELOPER_APP_REVIEWS.vscode,
    baseCounts: {
      'macos-arm64': 48,
      'macos-x64': 43,
      'windows-x64': 99,
      'linux-deb': 46,
      'linux-universal': 36,
    },
    platforms: {
      macos: [
        { id: 'macos-arm64', label: 'macOS (Apple Silicon)', type: 'api', platform: 'macos-arm64' },
        { id: 'macos-x64', label: 'macOS (Intel)', type: 'api', platform: 'macos-x64' },
      ],
      windows: [
        { id: 'windows-x64', label: 'Windows (x64)', type: 'api', platform: 'windows-x64' },
      ],
      linux: [
        {
          id: 'linux-deb',
          label: 'Linux (Debian/Ubuntu 24+)',
          type: 'api',
          platform: 'linux-deb',
        },
        {
          id: 'linux-universal',
          label: 'Linux (Universal)',
          type: 'api',
          platform: 'linux-universal',
        },
      ],
    },
  },
  {
    id: 'hireproof',
    name: 'HireProof',
    description: 'AI-powered hiring assessment platform for non-developer roles.',
    accent: '#FF4FA3',
    icon: 'hireproof',
    detailNote:
      'HireProof supports roles such as Designer, Marketing Manager, Finance Manager, Virtual Assistant, Recruiter, Customer Support, Sales, Operations Manager, Social Media Manager, Community Manager, HR Manager, Project Manager, and any custom non-technical role.',
    baseCounts: {
      'macos-x64': 128,
      'windows-x64': 215,
      'linux-universal': 56,
    },
    platforms: {
      macos: [
        {
          id: 'macos-x64',
          label: 'macOS (x64)',
          type: 'local',
          url: '/app/HireProof-3.1.6-x64.dmg',
        },
      ],
      windows: [
        {
          id: 'windows-x64',
          label: 'Windows (x64)',
          type: 'local',
          url: '/app/HireProof-3.1.6.exe',
        },
      ],
      linux: [
        {
          id: 'linux-universal',
          label: 'Linux (Universal)',
          type: 'local',
          url: '/app/HireProof-3.1.6.tar.gz',
        },
      ],
    },
    reviews: [
      {
        id: 'pragya-pahari',
        name: 'Pragya Pahari',
        role: 'Designer',
        image: '/img/review/hireproof/Pragya Pahari-Designer.jpeg',
        createdAt: hireProofCommittedAt(0, 11, 77),
        style: 'long',
        comment:
          'As a designer candidate, HireProof felt practical. The tasks looked like real design work, not generic quiz questions, so I could show how I think about layout, feedback, and tradeoffs.',
      },
      {
        id: 'alok-jain',
        name: 'Alok Jain',
        role: 'CEO at Moonpreneur Inc',
        image: '/img/review/hireproof/Alok Jain-CEO at Moonpreneur Inc.jpeg',
        createdAt: hireProofCommittedAt(1, 11, 77),
        style: 'short',
        comment:
          'We get clearer shortlists now, with enough signal to decide who should move to a live interview.',
      },
      {
        id: 'emily-dugan',
        name: 'Emily Dugan',
        role: 'Marketing Manager',
        image: '/img/review/hireproof/Emily Dugan-Markeing Manager.jpeg',
        createdAt: hireProofCommittedAt(2, 11, 77),
        style: 'short',
        comment: 'Good coverage of campaign judgment and communication.',
      },
      {
        id: 'ali-n',
        name: 'Ali N',
        role: 'Finance Manager',
        image: '/img/review/hireproof/Ali N-finance Manager.jpeg',
        createdAt: hireProofCommittedAt(3, 11, 77),
        style: 'short',
        comment:
          'It shows how candidates think through finance scenarios before we invest time in a long interview loop.',
      },
      {
        id: 'jay-sarwar',
        name: 'Jay Sarwar',
        role: 'CEO at Pendoah',
        image: '/img/review/hireproof/Jay Sarwar-CEO at Pendoah.jpeg',
        createdAt: hireProofCommittedAt(4, 11, 77),
        style: 'short',
        comment: 'Gives hiring managers evidence, not just resumes.',
      },
      {
        id: 'basma-khalaf',
        name: 'Basma Khalaf',
        role: 'Designer',
        image: '/img/review/hireproof/Basma Khalaf-Designer.jpeg',
        createdAt: hireProofCommittedAt(5, 11, 77),
        style: 'short',
        comment:
          'The design tasks felt fair and close to real work, so I could show my process clearly.',
      },
      {
        id: 'kellie-tolloti',
        name: 'Kellie Tolloti',
        role: 'Marketing Manager',
        image: '/img/review/hireproof/Kellie (Dempsey) Tolloti-marketing manager.jpeg',
        createdAt: hireProofCommittedAt(6, 11, 77),
        style: 'long',
        comment:
          'We use HireProof for marketing manager and social media hiring. Scoring is fast enough that we do not stall, and quality is still high enough to send a shortlist to leadership.',
      },
      {
        id: 'zul-momin',
        name: 'Zul Momin',
        role: 'CEO at Carexion',
        image: '/img/review/hireproof/Zul Momin-CEO at Carexion.jpeg',
        createdAt: hireProofCommittedAt(7, 11, 77),
        style: 'short',
        comment:
          'We use it as the first filter for support and operations hiring so managers only meet stronger candidates.',
      },
      {
        id: 'phuc-tran',
        name: 'Phuc Tran',
        role: 'Finance Manager',
        image: '/img/review/hireproof/Phuc Tran-Finance Manager.jpeg',
        createdAt: hireProofCommittedAt(8, 11, 77),
        style: 'short',
        comment: 'Role-specific and professional as a finance candidate.',
      },
      {
        id: 'raj-singh',
        name: 'Raj Singh',
        role: 'CEO at Purpose',
        image: '/img/review/hireproof/Raj Singh-CEO at Purpose.jpeg',
        createdAt: hireProofCommittedAt(9, 11, 77),
        style: 'short',
        comment:
          'Comparisons across candidates feel fairer because everyone completes the same role-based assessment.',
      },
      {
        id: 'riad-jabali',
        name: 'Riad Jabali',
        role: 'CEO at Wowkode',
        image: '/img/review/hireproof/Riad Jabali-CEO at wowkode.jpeg',
        createdAt: hireProofCommittedAt(10, 11, 77),
        style: 'long',
        comment:
          'HireProof is focused on non-developer roles, which is what we needed. Assessments for recruiters, assistants, and managers feel relevant, and the team can run them without extra setup.',
      },
    ],
  },
  {
    id: 'claude',
    name: 'Claude',
    description: 'Desktop assistant for planning, writing, coding, and communication tasks.',
    accent: '#D97757',
    icon: 'claude',
    reviews: DEVELOPER_APP_REVIEWS.claude,
    baseCounts: {
      'macos-arm64': 54,
      'macos-x64': 30,
      'windows-x64': 77,
      'linux-universal': 62,
    },
    platforms: {
      macos: [
        { id: 'macos-arm64', label: 'macOS (Apple Silicon)', type: 'api', platform: 'macos-arm64' },
        { id: 'macos-x64', label: 'macOS (Intel)', type: 'api', platform: 'macos-x64' },
      ],
      windows: [
        { id: 'windows-x64', label: 'Windows (x64)', type: 'api', platform: 'windows-x64' },
      ],
      linux: [
        {
          id: 'linux-universal',
          label: 'Linux (Universal)',
          type: 'api',
          platform: 'linux-universal',
        },
      ],
    },
  },
];

export const getOtherAppById = (id) =>
  OTHER_APPS.find((app) => app.id === String(id || '').toLowerCase()) || null;
